import { Task, TaskStatusType, getTaskStatus } from "../types";

/**
 * Calculate status counts from a list of tasks
 */
export const calculateStatusCounts = (tasks: Task[]) => {
  const counts = {
    all: tasks.length,
    "not-started": 0,
    "in-progress": 0,
    completed: 0,
  };

  tasks.forEach((task) => {
    const status = getTaskStatus(task);
    counts[status] = (counts[status] || 0) + 1;
  });

  return counts;
};

/**
 * Filter tasks by search query
 */
export const filterTasksBySearch = (tasks: Task[], searchQuery: string): Task[] => {
  if (!searchQuery.trim()) return tasks;

  const query = searchQuery.toLowerCase();
  return tasks.filter((task) => {
    const name = task.node?.display || task.more?.name || "";
    const region = task.node?.piv_level1 || "";
    const userName = task.user?.name || "";
    return (
      name.toLowerCase().includes(query) ||
      region.toLowerCase().includes(query) ||
      userName.toLowerCase().includes(query)
    );
  });
};

/**
 * Filter tasks by status
 */
export const filterTasksByStatus = (tasks: Task[], selectedStatuses: TaskStatusType[]): Task[] => {
  if (selectedStatuses.length === 0) return tasks;

  return tasks.filter((task) => {
    const status = getTaskStatus(task);
    return selectedStatuses.includes(status);
  });
};

/**
 * Calculate completed count for a task
 * This fixes the bug where two values were concatenated
 */
export const getCompletedCount = (task: Task): number => {
  const totalCount = task.count?.count || 0;
  const pending = task.status?.pending || 0;
  return Math.max(0, totalCount - pending);
};

